import type {
  createRoundingAliasesFn,
  createRoundingFn,
  createRoundingGlobalsFn,
} from "./types";

export const roundingGlobals = {
  sm: 2,
  md: 4,
  lg: 8,
  xl: 10,
  xxl: 12,
};

export const createRoundingAliases: createRoundingAliasesFn = (rounding) => {
  return {
    banner: rounding.md,
    raisedSurface: rounding.md,
  };
};

export const createRoundingGlobals: createRoundingGlobalsFn = () => {
  return roundingGlobals;
};

export const createRounding: createRoundingFn = () => {
  const aliases = createRoundingAliases(roundingGlobals);

  return {
    ...roundingGlobals,
    ...aliases,
  };
};
